import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardWidget from "../card-widget/CardWidget";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import Api from "../../services/api/Api";
import {ApiPaths} from "../../services/api/ApiPaths";
import CardWidgetTextInput from "../card-widget/CardWidgetTextInput";
import CardWidgetErrorsContainer from "../card-widget/CardWidgetErrorsContainer";
import {RouteConstants} from "../route/services/RouteConstants";
import { getLanguage } from "../../store/rootReducer";
import ValidationService from "../registration/services/ValidationService";
import {USER_CREATION_STATE} from "../common/UserCreationState";

class ForgotUserNameForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null
    };
  }

  goBack = () => {
    this.props.history.goBack();
  };

  validateUserRecoveryData = (data) => {
    if (!ValidationService.isValidEmail(data, true)) {
      return 'forgot_username.empty_username_error';
    }
  };

  submitUser = () => {
    let uiValidationError = this.validateUserRecoveryData(this.recoveryData);
    if (uiValidationError) {
      this.setState({
        errorMessage: uiValidationError
      });
      return;
    }
    let request = {"recoveryData": this.recoveryData, "lang": this.props.language};
    Api.post(ApiPaths.FORGOT_USERNAME, request).then(
        (response) => {
           if (response.data.userCreationState === USER_CREATION_STATE.IN_PROCESS) {
                this.props.history.push(RouteConstants.INCOMPLETE_REGISTRATION);
                this.props.history.push({
                    pathname: RouteConstants.INCOMPLETE_REGISTRATION,
                    state: { email: this.recoveryData }
                })
            } else{
                this.props.history.push(RouteConstants.FORGOT_USERNAME_SENT);
            }
        },
        (error) => {
          this.setState({
            errorMessage: "common.general_processing_error"
          });
        }
    )
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.submitUser();
  };

  handleChange = (e) => {
    this.recoveryData = e.target.value;
  };

  getCardContent = () => {
    return (
        <form onSubmit={this.handleSubmit}>
          <CardWidgetContent contentText="forgot_username.content"/>
          <CardWidgetErrorsContainer errorMessage={this.state.errorMessage}/>
          <CardWidgetTextInput fieldLabel="forgot_username.text_label" onChange={this.handleChange}/>
        </form>
    );
  };

  render() {
    return (
        <CardWidget
            getCardContent={this.getCardContent}
            submitButtonAction={this.submitUser}
            submitButtonText="forgot_username.next"
            cancelButtonAction={this.goBack}
            cancelButtonText="forgot_username.cancel"
        />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  };
};

export default connect(mapStateToProps)(ForgotUserNameForm);